export enum ProjectWidgetComponentIds {
  Root = '#projectWidgetRoot1',
  Gallery = '#projectGallery1',
  Header = '#projectHeaderWidget1',
  NavigationWidget = '#navigationWidget1',
}

export enum ProjectWidgetEvents {}
// Change = 'change',
